import { ICON__download_solid } from '@/assets/icons_fa';
import { HOOK_IMAGE__download } from '@/hooks/image/HOOK_IMAGE__download';
import { CONTEXT_MENU_ITEM__field_base } from '@/pages/page_generation/sidebar/_base/context_menu/_base/CONTEXT_MENU_ITEM__field_base';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

interface PROPS {
  image_asset: DTO__image_asset;
}

export function CONTEXT_MENU_ITEM__image__download({ image_asset }: PROPS) {
  /*
   *
   */

  const { download_image } = HOOK_IMAGE__download();

  /*
   *
   */

  async function onClick(): Promise<void> {
    download_image(image_asset);
  }

  /*
   *
   */

  if (image_asset.is_stub()) return null;
  if (image_asset.is_single_color) return null;

  return <CONTEXT_MENU_ITEM__field_base Icon={ICON__download_solid} text={'Download'} on_click={onClick} />;
}
